const SignIn = () => import('@/features/signin/views/SignInView.vue')
const SignUp = () => import('@/features/signin/views/SignUpView.vue')
const SignOut = () => import('@/features/signin/views/SignOutView.vue')
const PasswordReset = () => import('@/features/signin/views/PasswordResetView.vue')
const PasswordForgot = () => import('@/features/signin/views/PasswordForgotView.vue')
const UserConfirmation = () => import('@/features/signin/views/UserConfirmationView.vue')
const SSOCallback = () => import('@/features/signin/views/SSOCallbackView.vue')
const ViewNoAccess = () => import('@/views/NoAccessView.vue')

export const authRoutes = [
    { path: '/sign-in', component: SignIn, meta: { title: 'Sign In' } },
    { path: '/sso-callback', component: SSOCallback, meta: { title: 'SSO Sign In' } },
    { path: '/sign-up', component: SignUp, meta: { title: 'Sign Up' } },
    { path: '/sign-out', component: SignOut, meta: { title: 'Sign Out' } },
    {
        path: '/user-confirmation',
        component: UserConfirmation,
        meta: { title: 'User Confirmation' },
    },
    { path: '/reset-password', component: PasswordReset },
    { path: '/forgot-password', component: PasswordForgot },
    { path: '/no-access', component: ViewNoAccess, meta: { title: 'No Access' } },
]
